import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  CREATE_BLOG,
  CREATE_CARRIER_JOB,
  CREATE_FAQ,
  CREATE_PAGE,
  DELETE_FAQ,
  FAQ_GET_ALL,
  FAQ_UPDATE_SORT_ORDER,
  GET_ALL_BLOG,
  GET_ALL_JOBS,
  GET_BLOG_BY_ID,
  GET_FAQ_BY_ID,
  GET_JOB_APPLICANTS,
  GET_JOB_BY_ID,
  GET_PAGE_BY_ID,
  GET_QUERY_LIST,
  PAGE_GET_ALL,
  PAGE_UPDATE_STATUS,
  RESPONED_TO_QUERY,
  UPDATE_APPLICANTS_STATUS,
  UPDATE_BLOG,
  UPDATE_BLOG_FEATURED,
  UPDATE_BLOG_STATUS,
  UPDATE_CAREER_JOB,
  UPDATE_FAQ,
  UPDATE_FEATURED_JOB,
  UPDATE_JOB_STATUS,
  UPDATE_PAGE,
} from "../../../config/apiUrlsAdmin";
import {
  GetUpdateSortOrderRequest,
  ICreateBlogRequest,
  ICreateCarrierRequest,
  ICreateFAQRequest,
  ICreatePageRequest,
  IUpdateAQRequest,
  IUpdateBlogStatusRequest,
  IUpdateCarrierRequest,
  IUpdateCustomerQueryRequest,
  IUpdateJobApplicationStatus,
  IUpdateJobFeatured,
  IUpdateJobStatus,
  IUpdatePageRequest,
  IUpdatePageStatusRequest,
} from "../../../types/Request/AdminRequest";
import {
  ApiResponse,
  ICreateCarrierResponse,
  ICreateFAQResponse,
  ICustomerQuery,
  ICustomerQueryDetails,
  IGetAllBlogResponse,
  IGetAllFaqResponse,
  IGetAllJobsResponse,
  IGetAllPageResponse,
  iGetBlogByIdResponse,
  IGetByIdFaqResponse,
  IGetByIdPageResponse,
  IGetJobByIdResponse,
} from "../../../types/Response/AdminResponse";

export const footerManagementAdminAPi = createApi({
  reducerPath: "footerManagementAdminAPi",
  baseQuery: axiosBaseQuery(),

  endpoints: (builder) => ({
    createcarrier: builder.mutation<
      ICreateCarrierResponse,
      ICreateCarrierRequest
    >({
      query: (data) => ({
        url: CREATE_CARRIER_JOB,
        method: "post",
        data: data,
      }),
    }),
    getAllJobscarrier: builder.query<IGetAllJobsResponse, void>({
      query: (data) => ({
        url: GET_ALL_JOBS,
        method: "get",
        data: data,
      }),
    }),
    getAllJobsById: builder.query<IGetJobByIdResponse, number>({
      query: (id) => ({
        url: `${GET_JOB_BY_ID}/${id}`,
        method: "get",
      }),
    }),
    updatecarrier: builder.mutation<
      ICreateCarrierResponse,
      IUpdateCarrierRequest
    >({
      query: (data) => ({
        url: UPDATE_CAREER_JOB,
        method: "put",
        data: data,
      }),
    }),
    updatecarrierStatus: builder.mutation<
      ICreateCarrierResponse,
      IUpdateJobStatus
    >({
      query: (data) => ({
        url: UPDATE_JOB_STATUS,
        method: "patch",
        data: data,
      }),
    }),
    updatecarrierFeatured: builder.mutation<
      ICreateCarrierResponse,
      IUpdateJobFeatured
    >({
      query: (data) => ({
        url: UPDATE_FEATURED_JOB,
        method: "patch",
        data: data,
      }),
    }),

    getAllJobApplicants: builder.query<ApiResponse, number>({
      query: (jobId) => ({
        url: `${GET_JOB_APPLICANTS}/${jobId}`,
        method: "get",
      }),
    }),

    updateApplicationStatus: builder.mutation<
      ICreateCarrierResponse,
      IUpdateJobApplicationStatus
    >({
      query: (data) => ({
        url: UPDATE_APPLICANTS_STATUS,
        method: "patch",
        data: data,
      }),
    }),

    ///////////  BLOGS ///////

    createBlog: builder.mutation<ICreateCarrierResponse, ICreateBlogRequest>(
      {
        query: (data) => ({
          url: CREATE_BLOG,
          method: "post",
          data: data,
        }),
      },
    ),
    getAllBlogs: builder.query<IGetAllBlogResponse, void>({
      query: (data) => ({
        url: GET_ALL_BLOG,
        method: "get",
        data: data,
      }),
    }),
    getBlogById: builder.query<iGetBlogByIdResponse, number>({
      query: (id) => ({
        url: `${GET_BLOG_BY_ID}/${id}`,
        method: "get",
      }),
    }),
    updateBlog: builder.mutation<ICreateCarrierResponse, ICreateBlogRequest>(
      {
        query: (data) => ({
          url: UPDATE_BLOG,
          method: "put",
          data: data,
        }),
      },
    ),
    updateBlogStatus: builder.mutation<
      ICreateCarrierResponse,
      IUpdateBlogStatusRequest
    >({
      query: (data) => ({
        url: UPDATE_BLOG_STATUS,
        method: "patch",
        data: data,
      }),
    }),
    updateBlogFeatured: builder.mutation<
      ICreateCarrierResponse,
      IUpdateJobFeatured
    >({
      query: (data) => ({
        url: UPDATE_BLOG_FEATURED,
        method: "patch",
        data: data,
      }),
    }),

    //Page

    CreatePage: builder.mutation<ICreateFAQResponse, ICreatePageRequest>({
      query: (data) => ({
        url: `${CREATE_PAGE}`,
        method: "post",
        data: data
      }),
    }),
    UpdatePage: builder.mutation<ICreateFAQResponse, IUpdatePageRequest>({
      query: (data) => ({
        url: `${UPDATE_PAGE}`,
        method: "put",
        data: data
      }),
    }),
    GetPageById: builder.query<IGetByIdPageResponse, number>({
      query: (id) => ({
        url: `${GET_PAGE_BY_ID}/${id}`,
        method: "get",
      }),
    }),

    GetAllPage: builder.query<IGetAllPageResponse, void>({
      query: () => ({
        url: `${PAGE_GET_ALL}`,
        method: "get"
      }),
    }),
    UpdatePageStatus: builder.mutation<IGetAllPageResponse, IUpdatePageStatusRequest>({
      query: (data) => ({
        url: `${PAGE_UPDATE_STATUS}`,
        method: "patch",
        data: data
      }),
    }),
    CreateFAQ: builder.mutation<ICreateFAQResponse, ICreateFAQRequest>({
      query: (data) => ({
        url: `${CREATE_FAQ}`,
        method: "post",
        data: data
      }),
    }),
    UpdateFAQ: builder.mutation<ICreateFAQResponse, IUpdateAQRequest>({
      query: (data) => ({
        url: `${UPDATE_FAQ}`,
        method: "put",
        data: data
      }),
    }),
    DeleteFAQ: builder.query<ICreateFAQResponse, number>({
      query: (id) => ({
        url: `${DELETE_FAQ}/${id}`,
        method: "delete"
      }),
    }),

    GetFaqById: builder.query<IGetByIdFaqResponse, number>({
      query: (id) => ({
        url: `${GET_FAQ_BY_ID}/${id}`,
        method: "get",
      }),
    }),

    GetAllFaq: builder.query<IGetAllFaqResponse, void>({
      query: () => ({
        url: `${FAQ_GET_ALL}`,
        method: "get"
      }),
    }),

    //UPDATE_FAQ_STATUS 

    UpdateSortOrderFAQ: builder.mutation<ICreateFAQResponse, GetUpdateSortOrderRequest>({
      query: (data) => ({
        url: `${FAQ_UPDATE_SORT_ORDER}`,
        method: "patch",
        data: data
      }),
    }),

    getQueryList: builder.query<ICustomerQuery[], void>({
      query: () => ({
        url: `${GET_QUERY_LIST}`,
        method: "get"
      }),
    }),
    
    GetQueryDetails: builder.query<ICustomerQueryDetails, number>({
      query: (queryId) => ({
        url: `${GET_QUERY_LIST}${queryId}`,
        method: "get"
      }),
    }),

        UpdateQuery: builder.mutation<boolean, IUpdateCustomerQueryRequest>({
      query: (data) => ({
        url: `${RESPONED_TO_QUERY}`,
        method: "put",
        data: data
      }),
    }),
  }),
});

export const {
  useCreatecarrierMutation,
  useGetAllJobscarrierQuery,
  useGetAllJobsByIdQuery,
  useUpdatecarrierMutation,

  useLazyGetAllJobApplicantsQuery,
  useUpdateApplicationStatusMutation,
  useUpdatecarrierFeaturedMutation,
  useUpdatecarrierStatusMutation,




  useCreateBlogMutation,
  useUpdateBlogMutation,
  useUpdateBlogFeaturedMutation,
  useUpdateBlogStatusMutation,
  useLazyGetAllBlogsQuery,
  useLazyGetBlogByIdQuery,

  useCreatePageMutation, useUpdatePageMutation, useLazyGetAllPageQuery, useUpdatePageStatusMutation, useLazyGetPageByIdQuery,
  useCreateFAQMutation, useUpdateFAQMutation, useLazyDeleteFAQQuery, useLazyGetAllFaqQuery,
  useLazyGetQueryDetailsQuery,
  useLazyGetQueryListQuery,
  useUpdateQueryMutation
} = footerManagementAdminAPi;
